import * as React from 'react';
import { Button } from '@/components/ui/button';

export function ConflictModal(props: {
  open: boolean;
  onReload: () => void;
  onOverwrite: () => void;
  onCancel: () => void;
}) {
  if (!props.open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-[420px] rounded bg-background p-4 shadow-xl">
        <h3 className="text-base font-semibold">Update conflict</h3>
        <p className="mt-2 text-sm text-muted-foreground">
          The flow was changed on the server. Choose how to resolve:
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="outline" onClick={props.onReload}>Reload remote</Button>
          <Button variant="destructive" onClick={props.onOverwrite}>Overwrite remote</Button>
          <Button variant="ghost" onClick={props.onCancel}>Cancel</Button>
        </div>
      </div>
    </div>
  );
}

export default ConflictModal;

